let appConfig = {
    apiPrefix: process.env.REACT_APP_API_BASE_URL,
    websitBaseUrl: process.env.REACT_APP_WEBSITE_BASE_URL,
    authenticatedEntryPath: '/dashboard',
    unAuthenticatedEntryPath: '/sign-in',
    tourPath: '/',
    locale: 'en',
    enableMock: false,
}

export default appConfig
